import { api } from '../libs/axios';
import { PaginationRequest, PaginationResponse } from '../types/communication/pagination';
import Subscription from '../types/entities/subscription';

export const getPaginatedSubscription = async (
    request?: PaginationRequest,
): Promise<PaginationResponse<Subscription, 'subscriptions'>> => {
    return api.get('/subscriptions', { params: request });
};
